<template>
    <section :id="component.identifier ? component.identifier : ''"  class="pt-64 mb-64 site__container flex justify-center">
    	<div v-html="twitterFeed"
            :key="rerenders"
            :class="[ feedWidth ]"
            class="border site__border--text-light"
       >
        </div>
    </section>
</template>

<script>
import { mapState } from 'pinia';
import { useCommonStore } from '../../state/common';
import { useBrandingStore } from '../../state/branding';
import { responsive } from '../../helpers';

export default {
    props: {
        component: {
            required: true,
        }
    },
    data: function () {
        return {}
    },
    computed: {
        ...mapState(useCommonStore, ['locale']),
        ...mapState(useBrandingStore, ['preview']),
        rerenders() {
            return this.component.rerenderCount;
        },
        twitterFeed: {
            get () {
                let feed = '<a class="twitter-timeline" href="https://twitter.com/jobtoolz?ref_src=twsrc%5Etfw">Tweets by jobtoolz</a>';

                let url = typeof this.component.translated_url[this.locale] !== 'undefined' &&
                    this.component.translated_url[this.locale].indexOf('<a') !== -1 ?
                    this.component.translated_url[this.locale] :
                    this.component.url;

                if (url.indexOf('<a') === -1) {
                    return feed;
                }

                let start = url.indexOf('<a');

                return url.substr(start, (url.indexOf('</a>') + 4) - start);
            }
        },
        feedWidth () {
            return responsive(this.preview.type, 'w-full md:w-2/3');
        }
    },
    methods: {
        waitForTwitter () {
            clearInterval(this._interval);
            twttr.events.bind(
            'loaded',
            e => {
                this.$emit('loaded');
            });
        }
    },
    mounted () {
    	let script = document.createElement('script');
	    script.setAttribute('src', 'https://platform.twitter.com/widgets.js');
        document.head.appendChild(script);

        this._interval = setInterval(() => {
            if (typeof twttr !== 'undefined') {
                this.waitForTwitter();
            }
        }, 200);
    },
    watch: {
        rerenders (value, oldValue) {
            twttr.widgets.load();
        }
    }
}
</script>
